// extracted by mini-css-extract-plugin
export var typingIndicator = "_pj-0";